import { useTranslation } from 'react-i18next'

import { Header } from '../../Modal'

function TableModalHeader({
  text = 'Modal.AttachedTitleKey',
  textVariables,
  ...restProps
}) {
  const { t } = useTranslation()

  return <Header {...restProps} text={t(text, textVariables)} />
}

export default TableModalHeader
